(function () {
  let syncing = false;
  let timer = null;

  // Reload guard key (prevents infinite loops)
  const RELOAD_KEY = 'assembly_cart_reload_lock';
  const RELOAD_TTL_MS = 2500; // 2.5s window is enough

  function debounce(ms = 400) {
    clearTimeout(timer);
    timer = setTimeout(syncAddons, ms);
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return await res.json();
  }

  async function changeByKey(key, quantity) {
    const payload = {
      id: key, // line item KEY
      quantity
    };

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });

    return await res.json();
  }

  function isAddon(item) {
    return item.properties && (item.properties._addon_for || item.properties._addon_type === 'assembly');
  }

  function setReloadLock() {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  }

  function hasRecentReloadLock() {
    const v = sessionStorage.getItem(RELOAD_KEY);
    if (!v) return false;
    const t = Number(v);
    if (!Number.isFinite(t)) return false;
    return (Date.now() - t) < RELOAD_TTL_MS;
  }

  function clearReloadLockSoon() {
    // clear after TTL so future cart actions can reload again if needed
    setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), RELOAD_TTL_MS);
  }

  function reloadCartPageOnce() {
    // Only reload on cart page
    if (window.location.pathname !== '/cart') return;

    // prevent loops
    if (hasRecentReloadLock()) return;

    setReloadLock();
    clearReloadLockSoon();

    // Add cache-busting param (optional)
    const url = new URL(window.location.href);
    url.searchParams.set('_assembly_refresh', String(Date.now()));
    window.location.replace(url.toString());
  }

  async function syncAddons() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();

      // Parent variant id -> qty
      const parentQty = new Map();
      cart.items.forEach((it) => {
        if (!isAddon(it)) parentQty.set(String(it.id), it.quantity); // it.id = variant id
      });

      const actions = [];

      // Find orphan addons or qty mismatches
      cart.items.forEach((it) => {
        if (!isAddon(it)) return;

        const parentId = it.properties?._addon_for;
        if (!parentId) return;

        // parent removed => remove addon
        if (!parentQty.has(String(parentId))) {
          actions.push({ key: it.key, quantity: 0 });
          return;
        }

        // qty mismatch => sync addon qty
        const desired = parentQty.get(String(parentId));
        if (desired !== it.quantity) {
          actions.push({ key: it.key, quantity: desired });
        }
      });

      if (!actions.length) return;

      // Apply changes
      for (const act of actions) {
        await changeByKey(act.key, act.quantity);
      }

      // ✅ Most reliable: reload cart page once to reflect empty state/totals
      reloadCartPageOnce();
    } catch (err) {
      console.error('Assembly addon sync error:', err);
    } finally {
      syncing = false;
    }
  }

  // Run on cart page load to clean orphan addons (if any)
  document.addEventListener('DOMContentLoaded', () => debounce(150));

  // Trigger after cart interactions
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button,a');
    if (!btn) return;

    // Dawn remove buttons
    if (btn.closest('cart-remove-button')) {
      debounce(700);
      return;
    }

    // Any direct cart/change link
    if ((btn.getAttribute('href') || '').includes('/cart/change')) {
      debounce(700);
      return;
    }

    // Some themes use buttons with name="update" or similar
    if (btn.matches('button[name="update"]')) {
      debounce(700);
      return;
    }
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;

    // Dawn quantity input
    if (t.matches('input.quantity__input') || t.matches('input[name="updates[]"]')) {
      debounce(700);
    }
  });
})();
